


























































import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api';
import ProductBox from '~/components/solepro/ProductBox.vue';
import { Pagination, Navigation } from 'swiper'
import { otherTemiCaldiProductLink, otherTemiCaldiNavLink } from '~/helpers/trackings/24orepro/pages';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

// Import Swiper styles
import 'swiper/swiper-bundle.css'
import { useApi, useConfig } from '~/composables';
import { GET_HOT_TOPICS } from '~/modules/catalog/category/queries/solepro/gotTopics.gql';
import { usePageResolver } from '~/stores/page';

SwiperCore.use([Pagination, Navigation])

import ClientOnly from 'vue-client-only';

export default defineComponent({
    props: {
        hotTopicsUid: {
            required: true,
            type: String
        },
        title: {
            type: String
        }
    },
    components: {
        ProductBox,
        Swiper,
        SwiperSlide,
        ClientOnly
    },
    setup(props) {
        const name = ref('');
        const items = ref([]);
        const { query } = useApi();
        const { resolveUrl } = usePageResolver();
        const { config } = useConfig(); 
        useFetch(async () => {
            const routeData = await resolveUrl();
            const { data } = await query(GET_HOT_TOPICS, { hotTopicsUid: props.hotTopicsUid });
            name.value = data['categories'].items[0].name;
            items.value = data['categories'].items[0].children.filter(el=>el.uid!=routeData.uid);
        })

        const swiperProps = {
            slidesPerView: "auto",
            spaceBetween: 12,
            modules: [Navigation, Pagination],
            slideClass: 'slide',
            pagination: {
                el: '.section-up-sell .pagination',
                type: 'progressbar',
                progressbarFillClass: 'bg-black w-full block h-full'
            },
            navigation: {
                prevEl: '.section-up-sell .navigation .prev-btn',
                nextEl: '.section-up-sell .navigation .next-btn',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1366: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        }

        const trackTemiCaldiLink = () => otherTemiCaldiProductLink(props.title);
        const trackOtherTemiCaldiNav = (val) => otherTemiCaldiNavLink(props.title, val)

        return {
            trackTemiCaldiLink,
            trackOtherTemiCaldiNav,
            name,
            items,
            swiperProps,
            storeCode: config.value.store_code
        }
    },
    methods: {
        calculateHeights(swiper) {
            const tallest = swiper.slides.reduce((tallest: Element, slide: Element) => {
                return slide.querySelector('.product-box').getBoundingClientRect().height > tallest.querySelector('.product-box').getBoundingClientRect().height ? slide : tallest;
            });
            const h = tallest.offsetHeight + 'px';
            swiper.slides.forEach(el => el.querySelector('.product-box').style.height = h)
        },
        afterInit(swiper) {
            setTimeout(() => {
                swiper.update();
                console.log('updated');
                //this.calculateHeights(swiper)
                console.log(swiper.slides.length)
            }, 0) /**@TODO  manage timing!*/
        }
    }
})
